import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  App,
  Button,
  Card,
  Checkbox,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tabs,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  addItem,
  getItemListDetails,
  getSearchApi,
  updateItem,
} from '../../../network/itemList';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getAllServicesAndItem } from '../../../network/Item';
import { getSupplier } from '../../../network/supplier';
import { useNavigate, useParams } from 'react-router-dom';
import { MdDelete } from 'react-icons/md';
import { PlusOutlined } from '@ant-design/icons';
import Heading from '../../common/Heading/Heading';
import UomList from './UomList';
import ItemListStock from './ItemListStock';
import TaxesList from './TaxesList';
import { getSearchPatients } from '../../../network/appointment';
import HeadingApp from '../../../hooks/HeadingApp';
import { RiAlignItemBottomFill } from 'react-icons/ri';

const AddItemStock = ({ t, edit }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { companyName, currentLang } = useSelector((state) => state.user);
  const [valueItem, setValueItem] = useState({});
  const [dataSourceUom, setDataSourceUom] = useState([]);
  const [dataSourceItem, setDataSourceItem] = useState([{}]);
  const [dataSourceTax, setDataSourceTax] = useState([]);
  const client = useQueryClient();
  const [form] = Form.useForm();
  const [searchTextUOM, setSearchTextUOM] = useState('');
  const { message } = App.useApp();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const isFixedAsset = Form.useWatch('is_fixed_asset', form);
  // console.log(isFixedAsset,"isFixedAsset");

  const { mutate: onAddItem } = useMutation({
    mutationKey: ['addItem'],
    mutationFn: (body) => (edit ? updateItem(body, id) : addItem(body)),
    onSuccess: (data) => {
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success(
        data?.message?.message ? data?.message?.message : 'Added successfully'
      );
      client.invalidateQueries({ queryKey: [queryKeys.getItem] });
      form.resetFields();
      navigate('/item-list');
    },
    onError: (error) => {
      setLoadingAdd(false);
      // message.error(error.response.data._server_messages);
      const serverMessages = JSON.parse(error.response.data._server_messages);
      const messageData = JSON.parse(serverMessages[0]);
      const title = messageData.title || 'Error';
      const messageContent = messageData.message || 'An error occurred';
      message.error({
        content: `${title}: ${messageContent.replace(/<[^>]*>/g, '')}`,
        duration: 5,
      });
    },
  });
  const {
    data: itemDetails,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [queryKeys.getItemPrice, id],
    queryFn: () => getItemListDetails(id),
    enabled: !!edit,
  });
  const { data: itemGroup } = useQuery({
    queryKey: [queryKeys.getItemGroupSearch],
    queryFn: () => getSearchApi('Item Group'),
    keepPreviousData: true,
  });
  const { data: stockUoms } = useQuery({
    queryKey: [queryKeys.getSearchuom, searchTextUOM],
    queryFn: () => getSearchPatients('UOM', searchTextUOM),
    keepPreviousData: true,
    enabled: searchTextUOM?.length >= 3 || searchTextUOM?.length === 0,
  });
  useEffect(() => {
    if (edit) {
      refetch();
    }
  }, [edit, refetch]);

  useEffect(() => {
    if (edit && itemDetails) {
      setDataSourceTax(itemDetails?.data.taxes ? itemDetails?.data.taxes : []);
      setDataSourceItem(
        itemDetails?.data.item_defaults ? itemDetails?.data.item_defaults : [{}]
      );
      setDataSourceUom(itemDetails?.data.uoms ? itemDetails?.data.uoms : [{}]);
      form.setFieldsValue({
        ...itemDetails?.data,
        disabled: itemDetails?.data?.disabled === 1 ? true : false,
        is_sales_item: itemDetails?.data?.is_sales_item === 1 ? true : false,
        is_stock_item: itemDetails?.data?.is_stock_item === 1 ? true : false,
        allow_negative_stock:
          itemDetails?.data?.allow_negative_stock === 1 ? true : false,
        auto_create_assets:
          itemDetails?.data?.auto_create_assets === 1 ? true : false,
        is_zero_rated: itemDetails?.data?.is_zero_rated === 1 ? true : false,
        is_fixed_asset: itemDetails?.data?.is_fixed_asset === 1 ? true : false,
        // is_stock_item: itemDetails?.data?.is_stock_item === 1 ? true : false,
        taxes: itemDetails?.data.taxes ? itemDetails?.data.taxes : [{}],
        uoms: itemDetails?.data.uoms ? itemDetails?.data.uoms : [{}],
        item_defaults: itemDetails?.data.item_defaults
          ? itemDetails?.data.item_defaults
          : [{}],
      });
    } else {
      form.resetFields();
    }
  }, [edit, itemDetails, form]);

  const onFinish = (values) => {
    setLoadingAdd(true);
    onAddItem({
      ...values,
      ...valueItem,
      item_defaults: values?.item_defaults?.map((item) => {
        return { ...item, company: companyName };
      }),
      disabled: values?.disabled ? 1 : 0,
      is_stock_item: values?.is_stock_item ? 1 : 0,
      grant_commission: values?.grant_commission ? 1 : 0,
      is_fixed_asset: values?.is_fixed_asset ? 1 : 0,
      auto_create_assets: values?.auto_create_assets ? 1 : 0,
      is_grouped_asset: values?.is_grouped_asset ? 1 : 0,
      is_zero_rated: values?.is_zero_rated ? 1 : 0,
      is_exempt: values?.is_exempt ? 1 : 0,
      allow_negative_stock: values?.allow_negative_stock ? 1 : 0,
      enable_deferred_expense: values?.enable_deferred_expense ? 1 : 0,
      enable_deferred_revenue: values?.enable_deferred_revenue ? 1 : 0,
      is_purchase_item: values?.is_purchase_item ? 1 : 0,
      delivered_by_supplier: values?.delivered_by_supplier ? 1 : 0,
      is_sales_item: values?.is_sales_item ? 1 : 0,
      uoms: dataSourceUom?.map((item) => ({
        ...item,
      })),
      item_defaults: dataSourceItem?.map((item) => ({
        ...item,
      })),
      taxes: dataSourceTax?.map((item) => ({
        ...item,
      })),
    });
  };
  const items = [
    {
      key: '1',
      label: t.details,
      children: (
        <Row gutter={[16, 0]}>
          {edit ? (
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="item_code"
                label={t.itemCode}
                rules={[{ required: true }]}
              >
                <Input placeholder={t.itemCode} disabled={edit} />
              </Form.Item>
            </Col>
          ) : null}
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item
              name="item_name"
              label={t.itemName}
              rules={[{ required: true }]}
            >
              <Input placeholder={t.itemName} />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item
              name="item_group"
              label={t.itemGroup}
              rules={[{ required: true }]}
            >
              <Select
                showSearch
                placeholder={t.itemGroup}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={itemGroup?.message?.map((item) => ({
                  value: item?.value,
                  label: item?.value,
                }))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item
              name="stock_uom"
              label={t.defaultUOM}
              rules={[{ required: true }]}
              // hidden={edit}
            >
              <Select
                showSearch
                // placeholder={t.uom}
                placeholder={t.defaultUOM}
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                onSearch={(value) => {
                  setSearchTextUOM(value);
                }}
                options={stockUoms?.message?.map((user) => ({
                  value: user.value,
                  label: user.value,
                }))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item
              name="opening_stock"
              label={t.openingStock}
              // hidden={edit}
              // rules={[{ required: true }]}
            >
              <Input
                type="number"
                min={0}
                placeholder={t.openingStock}
                disabled={edit}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item
              name="valuation_rate"
              label={t.valuationRate}
              // rules={[{ required: true }]}
              // hidden={edit}
            >
              <Input
                type="number"
                min={0}
                placeholder={t.valuationRate}
                disabled={
                  edit
                    ? form.getFieldValue('valuation_rate') > 0
                      ? true
                      : false
                    : false
                }
              />
            </Form.Item>
          </Col>

          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item
              name="standard_rate"
              label={t.standardRate}
              // hidden={edit}
              // rules={[{ required: true }]}
            >
              <Input
                type="number"
                min={0}
                placeholder={t.standardRate}
                // disabled
                disabled={edit}
              />
            </Form.Item>
          </Col>
          <Divider />
          <Col
            sm={12}
            md={12}
            lg={8}
            xl={6}
            // className="flex items-center justify-start"
          >
            <Form.Item
              name="disabled"
              label={t.disabled}
              valuePropName="checked"
              layout="horizontal"
              // className="margin-bottom-0"
            >
              <Checkbox />
            </Form.Item>
          </Col>
          <Col
            sm={12}
            md={12}
            lg={8}
            xl={6}
            // className="flex items-center justify-start"
          >
            <Form.Item
              name="is_stock_item"
              label={t.maintainStock}
              valuePropName="checked"
              layout="horizontal"
              initialValue={1}
              // className="margin-bottom-0"
            >
              <Checkbox />
            </Form.Item>
          </Col>
          <Col sm={12} md={12} lg={8} xl={6}>
            <Form.Item
              name="is_fixed_asset"
              label={t.isFixedAsset}
              valuePropName="checked"
              layout="horizontal"
            >
              <Checkbox />
            </Form.Item>
          </Col>
          <Col sm={12} md={12} lg={8} xl={6}>
            <Form.Item
              name="is_zero_rated"
              label={t.isZeroRated}
              valuePropName="checked"
              layout="horizontal"
            >
              <Checkbox />
              {/* <Checkbox>{t.zeroRated}</Checkbox> */}
            </Form.Item>
          </Col>
          {isFixedAsset ? (
            <Col sm={12} md={12} lg={8} xl={6}>
              <Form.Item
                name="auto_create_assets"
                label={t.autoCreateAssets}
                valuePropName="checked"
                layout="horizontal"
              >
                <Checkbox />
              </Form.Item>
            </Col>
          ) : null}
          {isFixedAsset ? (
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="asset_category"
                label={t.assetCategory}
                rules={[{ required: isFixedAsset }]}
              >
                <Input placeholder={t.assetCategory} />
                {/* <Select placeholder={t.assetCategory}>
              <Select.Option value="Fixed Asset">{t.fixedAsset}</Select.Option>
            </Select> */}
              </Form.Item>
            </Col>
          ) : null}
          <Col span={24}>
            <Form.Item name="description" label={t.description}>
              <Input.TextArea
                autoSize={{ minRows: 5, maxRows: 5 }}
                placeholder={t.description}
              />
            </Form.Item>
          </Col>
        </Row>
      ),
    },
    {
      key: '2',
      label: t.inventory,
      children: (
        <Row gutter={[30, 0]}>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item name="valuation_method" label={t.valuationMethod}>
              <Select placeholder={t.valuationMethod}>
                <Select.Option value="empty">empty</Select.Option>
                <Select.Option value="FIFO">FIFO</Select.Option>
                <Select.Option value="LIFO">LIFO</Select.Option>
                <Select.Option value="Moving Average">
                  Moving Average
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col
            sm={12}
            md={12}
            lg={12}
            xl={12}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <Form.Item
              name="allow_negative_stock"
              label={t.allowNegativeStock}
              valuePropName="checked"
              layout="horizontal"
              className="margin-bottom-0"
            >
              <Checkbox />
              {/* <Checkbox>{t.allowNegativeStock}</Checkbox> */}
            </Form.Item>
          </Col>
          {/* <Col span={24} className="items-form-add">
                  <Form.List name="uoms" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields?.map(({ key, name, ...restField }) => {
                          // console.log(fields, 'restField');
                          return (
                            <Flex
                            gap={5}
                              justify="space-between"
                              align="center"
                              key={key}
                              style={{
                                width: '100%',
                              }}
                              // align="baseline"
                            >
                              <Form.Item
                                name={[name, 'uom']}
                                label={t.uom}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                              >
                                <Select
                                  showSearch
                                  placeholder={t.uom}
                                  optionFilterProp="children"
                                  filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                  }
                                  options={stockUoms?.message?.map((item) => ({
                                    value: item?.value,
                                    label: item?.value,
                                  }))}
                                />
                              </Form.Item>
                              <Form.Item
                                name={[name, 'conversion_factor']}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                label={t.conversionFactor}
                              >
                                {
                                  <Input
                                    placeholder={t.conversionFactor}
                                    style={{ width: '100%' }}
                                    type='number'
                                    min={0}
                                  />
                                }
                              </Form.Item>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '15px',
                                    margin: '0 10px',
                                  }}
                                >
                                  <Button
                                    type="text"
                                    onClick={() => add()}
                                    icon={<PlusOutlined color="#1890ff" />}
                                  />
                                  {fields.length > 1 && (
                                    <Button
                                      type="text"
                                      onClick={() => remove(name)}
                                      danger
                                      icon={<MdDelete color="red" />}
                                    />
                                  )}
                                 
                                </div>
                            </Flex>
                          );
                        })}
                      </>
                    )}
                  </Form.List>
                </Col> */}
          <Col span={24}>
            <UomList
              form={form}
              t={t}
              dataSourceUom={dataSourceUom}
              setDataSourceUom={setDataSourceUom}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: '3',
      label: t.accounts,
      children: (
        <Row gutter={[16, 0]}>
          <Col span={24}>
            <ItemListStock
              t={t}
              currentLang={currentLang}
              form={form}
              dataSourceItem={dataSourceItem}
              setDataSourceItem={setDataSourceItem}
            />
          </Col>
        </Row>
      ),
    },
    {
      key: '4',
      label: t.purchasing,
      children: (
        <Row gutter={[30, 0]}>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item name="purchase_uom" label={t.purchaseUOM}>
              <Select
                showSearch
                placeholder={t.purchaseUOM}
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                onSearch={(value) => {
                  setSearchTextUOM(value);
                }}
                onChange={(value) => {
                  setSearchTextUOM('');
                }}
                options={stockUoms?.message?.map((item) => ({
                  value: item?.value,
                  label: item?.value,
                }))}
              />
            </Form.Item>
          </Col>

          <Col
            sm={12}
            md={12}
            lg={8}
            xl={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <Form.Item
              name="is_purchase_item"
              label={t.isPurchaseItem}
              valuePropName="checked"
              layout="horizontal"
              className="margin-bottom-0"
              initialValue={true}
            >
              <Checkbox />
              {/* <Checkbox>{t.isPurchaseItem}</Checkbox> */}
            </Form.Item>
          </Col>
        </Row>
      ),
    },
    {
      key: '5',
      label: t.salse,
      children: (
        <Row gutter={[16, 0]}>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item name="sales_uom" label={t.salesUom}>
              <Select
                showSearch
                placeholder={t.purchaseUOM}
                optionFilterProp="children"
                filterOption={false}
                popupMatchSelectWidth={false}
                onSearch={(value) => {
                  setSearchTextUOM(value);
                }}
                onChange={(value) => {
                  setSearchTextUOM('');
                }}
                options={stockUoms?.message?.map((item) => ({
                  value: item?.value,
                  label: item?.value,
                }))}
              />
            </Form.Item>
          </Col>
          <Col xs={24} md={12} xl={8} xxl={8}>
            <Form.Item name="max_discount" label={t.maxDiscount + ' (%)'}>
              <Input
                placeholder={t.maxDiscount}
                type="number"
                min={0}
                max={100}
                prefix={'%'}
              />
            </Form.Item>
          </Col>
          <Col
            sm={12}
            md={12}
            lg={8}
            xl={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <Form.Item
              name="is_sales_item"
              label={t.isSalesItem}
              valuePropName="checked"
              layout="horizontal"
              className="margin-bottom-0"
              initialValue={true}
            >
              <Checkbox />
            </Form.Item>
          </Col>
          <Col
            sm={12}
            md={12}
            lg={8}
            xl={6}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <Form.Item
              name="grant_commission"
              label={t.grantCommission}
              valuePropName="checked"
              layout="horizontal"
              className="margin-bottom-0"
            >
              <Checkbox />
            </Form.Item>
          </Col>
        </Row>
      ),
    },
    {
      key: '6',
      label: t.taxes,
      children: (
        <>
          <Col span={24} className="items-form-add">
            {/* <Form.List name="taxes" style={{ width: '100%' }}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields?.map(({ key, name, ...restField }) => {
                          // console.log(fields, 'restField');
                          return (
                            <Flex
                            gap={5}
                              justify="space-between"
                              align="center"
                              key={key}
                              style={{
                                width: '100%',
                              }}
                              // align="baseline"
                            >
                              <Form.Item
                                name={[name, 'item_tax_template']}
                                label={t.itemTaxTemplate}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                              >
                                <Select
                                  placeholder={t.itemTaxTemplate}
                                  style={{ width: '100%' }}
                                  
                                  options={ItemTaxTemplate?.message?.map((item) => ({
                                    label: item.description,
                                    value: item.value,
                                  }))}
                                />
                              </Form.Item>
                              <Form.Item
                                name={[name, 'minimum_net_rate']}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                label={t.minimumNetRate}
                              >
                                {
                                  <Input
                                    placeholder={t.AccountHead}
                                    style={{ width: '100%' }}
                                    type='number'
                                    min={0}
                                  />
                                }
                              </Form.Item>
                              <Form.Item
                                name={[name, 'maximum_net_rate']}
                                style={{
                                  width: '100%',
                                  marginBottom: '0px',
                                }}
                                {...restField}
                                label={t.maximumNetRate}
                              >
                                <Input
                                  placeholder={t.TaxRate}
                                  style={{ width: '100%' }}
                                  type='number'
                                  min={0}
                                />
                              </Form.Item>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    fontSize: '15px',
                                    margin: '0 10px',
                                  }}
                                >
                                  <Button
                                    type="text"
                                    onClick={() => add()}
                                    icon={<PlusOutlined color="#1890ff" />}
                                  />
                                  {fields.length > 1 && (
                                    <Button
                                      type="text"
                                      onClick={() => remove(name)}
                                      danger
                                      icon={<MdDelete color="red" />}
                                    />
                                  )}
                                 
                                </div>
                            </Flex>
                          );
                        })}
                      </>
                    )}
                  </Form.List> */}
            <TaxesList
              form={form}
              t={t}
              setDataSourceTax={setDataSourceTax}
              dataSourceTax={dataSourceTax}
            />
          </Col>
        </>
      ),
    },
  ];
  if (isLoading) {
    return (
      <Card>
        <div
          style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size="large" />
        </div>
      </Card>
    );
  }
  return (
    <>
      {/* <Heading
        title={t.Inventory}
        subTitle={edit ? t.editItems : t.AddItem}
        path="/item-list"
      /> */}
      <HeadingApp
        nameTab={t.Inventory}
        title={t.item}
        subTitle={edit ? t.editItems : t.AddItem}
        icon={<RiAlignItemBottomFill />}
      />
      <Card style={{ borderRadius: '0px' }}>
        <Form
          form={form}
          name="add-Item-Price"
          layout="vertical"
          onFinish={onFinish}
          style={{
            marginTop: '20px',
          }}
          initialValues={{
            taxes: [{}],
            uoms: [{}],
            item_defaults: [{}],
          }}
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={24} lg={18}>
              <Row gutter={[16, 0]}>
                {/* <Divider orientation="left">{t.itemDetails}</Divider>
          <Divider orientation="left">{t.inventoryDetails}</Divider>
          <Divider orientation="left">{t.purchaseDetails}</Divider>
          <Divider orientation="left">{t.salesDetails}</Divider>
          <Divider orientation="left">{t.taxes}</Divider>      
          <Divider orientation="left">{t.itemDefaults}</Divider> */}
                <Tabs
                  defaultActiveKey="1"
                  items={items}
                  style={{ width: '100%', padding: '0 20px' }}
                />
              </Row>

              <div className="form-btns">
                <Button
                  type="primary"
                  ghost
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t.cancel}
                </Button>
                <Button type="primary" htmlType="submit" loading={loadingAdd}>
                  {edit ? t.edit : t.submit}
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};

export default AddItemStock;
